
import { Icon, InlineIcon } from "@iconify/vue";
import flagIcon from "@iconify-icons/dashicons/flag";
import { defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  name: "Home",
  store,
  data: function() {
    return {
      icons: {
        flag: flagIcon
      }
    };
  },
  components: {
    Icon
  }
});
